import { toast } from "react-toastify";
import { _IncidentReport, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { useEffect, useRef } from "react";

interface Props {
    setOnSubmit: (fn: () => void) => void;
    onSubmitClose: () => void;
}

export const IncidentSupport = ({ setOnSubmit, onSubmitClose }: Props) => {

    const { instance, bean, setBean } = useDataBean(_IncidentReport);
    const descriptionRef = useRef<string>("");

    useEffect(() => {
        descriptionRef.current = bean.Description ?? "";
    }, [bean.Description]);

    useEffect(() => {
        setOnSubmit(() => submitIncident);
    }, []);

    const submitIncident = () => {
        const description = descriptionRef.current;

        if (!description.trim()) {
            toast.warning("Debe ingresar una descripción");
            return;
        }

        instance.createIncidentReport(_single.getAccountID(), description).then(
            (resp) => {
                console.log(resp)
                setBean({});
                descriptionRef.current = "";
                if (resp.IDIncidentReport) {
                    onSubmitClose();
                    toast.success(
                        `Incidencia reportadacon el codigo ${resp.IncidenceCode}`
                    );
                } else {
                    toast.error("No se pudo registrar la incidencia.")
                }
            })
            .catch((error) => {
                toast.error(error);
            });
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <label>Descripción de la Incidencia</label>
                <textarea
                    className="form-control"
                    placeholder="¿En qué podemos ayudarte? Describe tu solicitud con el mayor detalle posible."
                    value={bean.Description || ""}
                    onChange={(e) =>
                        setBean({ ...bean, Description: e.target.value })
                    }
                />
                <span>
                    <strong>Nota:</strong>
                    <p>
                        Esta solicitud será enviada para gestión del proveedor tecnológico del ERP.
                    </p>
                </span>
            </div>
        </div>
    );
};
